import React from 'react';


export const useIntervalMemo = <T>(factory: () => T, intervalMS: number, deps?: React.DependencyList) => {
  const [ value, setValue ] = React.useState(factory);

  React.useEffect(() => {
    const interval = setInterval(() => {
      const newValue = factory();

      if (newValue !== value) {
        setValue(newValue);
      }
    }, intervalMS);

    return () => clearInterval(interval);
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps

  return value;
};
